import { useState, useEffect} from 'react';
import styles from '../styles/body.module.scss'
import {Box} from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function Home({siteId, setSiteId, displayInactivity }) {
  const navigate = useNavigate();
  const[update, setUpdate] = useState(false);

  useEffect(() => {
    let sId = localStorage.getItem('site_id');
    
    if(sId != null && sId != undefined && sId != 0){
      setSiteId(sId)

      setUpdate(true)
    }
  }, [siteId]);

  useEffect(() => {
    if(update){
      navigate("/site/"+siteId);
    }
  }, [update]);


  return (
    <div>
      <Box className={styles.questionH1Top} >
        <h1 className={styles.bottomParagraph}>Luddon Attendance</h1>
        </Box>
      <Box className={styles.questionH1} >
            <p className={styles.bottomParagraph}>
            Please scan the QR code at the site entrance or exit in order to sign in or sign out of site.
          </p>
      </Box>
      {displayInactivity && (
        <Box className={styles.questionH1} >
            <p className={styles.bottomRedParagraph}>
            You have been inactive for too long. Please rescan the QR code for Luddon Attendance.
          </p>
        </Box>
      )}
      <div className={styles.bottomDiv}>
          <p className={styles.bottomParagraph}>
            Were you looking for Luddon OnSite? <a href="https://luddononsite.co.uk/" target="_blank" >Click Here</a>.
          </p>
      </div>
        
    </div>
  );
}

